export default __webpack_public_path__ + "static/media/treadmill.85a7449f.svg";